var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 286.424,
    height: 209.153,
    viewBox: "0 0 286.424 209.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:#434343;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.122,
    y1: 1.111,
    x2: 0.854,
    y2: 0.088,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6359c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ca268b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#de1779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#eb0d6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef0a6a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    y1: 0.5,
    x2: 0.999,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b6359c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef0a6a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.53 -5.74)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M406.969,5.787V5.74H354.584v.013a13.025,13.025,0,1,0,0,26.05v.011h53.793a39.152,39.152,0,0,1-1.344,78.282h-.069v-.069H302.44v.013a13.133,13.133,0,0,0,0,26.258v.013H406.964a65.261,65.261,0,0,0,.005-130.523Z",
    transform: "translate(-230.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M446.87,320.986V321h78.459a13.149,13.149,0,0,0-.115-26.3c-.144,0-.283.016-.428.022H446.87v.013a13.13,13.13,0,0,0,0,26.252Z",
    transform: "translate(-348.745 -236.812)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M8.53,957.66H25.855c12.142,0,20.461,7.063,20.461,18.315S38,994.293,25.855,994.293H8.53Zm16.9,28.364c6.228,0,10.415-3.716,10.415-10.048s-4.187-10.048-10.415-10.048H18.9v20.1Z",
    transform: "translate(0 -780.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M264.677,1013.927v15.753h-9.263v-3.664c-1.413,2.722-4.239,4.135-8.372,4.135-6.8,0-10.572-3.82-10.572-8.74,0-5.234,3.82-8.482,12.611-8.482h5.652c-.157-2.878-2.093-4.5-6.017-4.5a13.216,13.216,0,0,0-7.693,2.46l-3.349-6.751c3.248-2.146,8.06-3.3,12.506-3.3C259.391,1000.844,264.677,1004.926,264.677,1013.927Zm-9.944,6.646v-2.46h-4.291c-3.191,0-4.342,1.151-4.342,2.887,0,1.675,1.361,2.888,3.716,2.888A4.936,4.936,0,0,0,254.733,1020.574Z",
    transform: "translate(-186.805 -815.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M437.449,1003.47l-11.73,28.366h-10.25L403.8,1003.47H414l6.8,17.325,7.17-17.325Z",
    transform: "translate(-323.938 -817.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M598.38,932.786c0-2.983,2.407-5.286,6.071-5.286s6.071,2.146,6.071,5.129c0,3.138-2.407,5.441-6.071,5.441S598.38,935.767,598.38,932.786Zm1.1,8.424h9.943v28.365h-9.943Z",
    transform: "translate(-483.403 -755.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M725.437,1013.473V1029.7h-9.944v-14.6c0-4.082-1.779-5.809-4.658-5.809-3.192,0-5.652,1.985-5.652,6.7V1029.7H695.24v-28.369h9.473v3.088a12.185,12.185,0,0,1,9-3.559C720.361,1000.86,725.437,1004.675,725.437,1013.473Z",
    transform: "translate(-562.783 -815.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M889.54,1015.461c0-8.53,6.751-14.6,16.276-14.6,6.437,0,11.357,2.878,13.291,7.8l-7.691,3.925c-1.361-2.669-3.349-3.82-5.652-3.82-3.454,0-6.176,2.407-6.176,6.7,0,4.4,2.722,6.8,6.176,6.8,2.3,0,4.292-1.151,5.652-3.821l7.691,3.925c-1.935,4.919-6.858,7.8-13.291,7.8C896.3,1030.167,889.54,1024.1,889.54,1015.461Z",
    transform: "translate(-722.019 -815.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1068.18,932.786c0-2.983,2.407-5.286,6.071-5.286s6.071,2.146,6.071,5.129c0,3.138-2.407,5.441-6.071,5.441S1068.18,935.767,1068.18,932.786Zm1.1,8.424h9.944v28.365h-9.944Z",
    transform: "translate(-868.421 -755.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1141.55,989.635l5.65-6.7c1.937,2.512,3.97,3.82,6.333,3.82,2.983,0,4.605-1.832,4.605-5.338V965.662h-12.665v-8h22.919v23.13c0,9.525-4.919,14.235-14.13,14.235C1148.927,995.025,1144.374,993.141,1141.55,989.635Z",
    transform: "translate(-928.55 -780.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1327.776,957.66v36.634h-10.362V965.662h-6.8v-8Z",
    transform: "translate(-1067.1 -780.132)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1458.785,982.525c0,6.542-4.919,12.508-15.962,12.508-5.077,0-10.467-1.263-14.183-3.609l3.716-7.8a18.6,18.6,0,0,0,10.153,3.035c3.507,0,5.862-1.413,5.862-3.873,0-2.25-1.518-3.716-7.118-3.716h-9.943l1.832-21.4h23.341v8h-14.759l-.471,5.338h2.46C1454.546,971.012,1458.785,976.036,1458.785,982.525Z",
    transform: "translate(-1163.831 -780.14)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBig);
export default __webpack_public_path__ + "static/media/Logo_Big.5235d8665164b5446dd3bdfb1d53a981.svg";
export { ForwardRef as ReactComponent };